import { Menu, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as FolderOpen } from '../../../res/svg/folder-open.svg';
import { ReactComponent as Copy } from '../../../res/svg/copy.svg';
import { ReactComponent as Download } from '../../../res/svg/download-black.svg';
import { ReactComponent as DeleteEnable } from '../../../res/svg/remove-outlined-enable.svg';
import { ReactComponent as DeleteDisable } from '../../../res/svg/remove-outlined-disable.svg';
import Task from '../../../models/Task';
import './DropDownMenu.less';
import { rolPermission } from '../../../utils/functions'
import User from '../../../models/User';
/**
 * @component DropDownMenu.tsx
 * @description DropDownMenu.
 * @return { Component }
 */
interface DropDownMenuProps {
  task: Task;
  deleteTaskModal?: (taskId: number) => void;
  actionCloneTask?: (taskId: number) => void;
  actionExportTask?: (taskId: number, titulo: string) => void;
}

function DropDownMenu(props: DropDownMenuProps) {
  const { Text } = Typography;
  let navigate = useNavigate();
  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'))
  const openTask = () => {
    navigate('visualizar/' + props.task.id, {
      state: { taskInformationFromTableOrCard: props.task },
    });
  };

  const deleteTaskAction = () =>{
    if(props.deleteTaskModal && props.task.id){
      props?.deleteTaskModal(props.task.id);
    }
  }

  const cloneTaskAction = () =>{
    if(props.actionCloneTask && props.task.id){
      props?.actionCloneTask(props.task.id);
    }
  }

  const exportTask = () =>{
    if(props.actionExportTask && props.task.id){
      props.actionExportTask(props.task.id, props.task.titulo!)
    }
  }

  const hideCloneDelete = () =>{
    let hide = true;
    if(currentUser.rol !== null){
      if(currentUser.rol.permiso === rolPermission.COORDINACION || currentUser.rol.permiso === rolPermission.AUTOGESTION){
        hide = false
      }
    }
    return hide;
  }

  const hideExport = () =>{
    let hide = false;
    if(currentUser.rol !== null){
      if(currentUser.rol.permiso === rolPermission.SUPERVISION){
        hide = true
      }
    }
    return hide;

  }

  const disabledDelete = () =>{
    let disabled = true;
    if(currentUser.rol !== null){
      if(currentUser.rol.permiso === rolPermission.COORDINACION || currentUser.rol.permiso === rolPermission.AUTOGESTION){
        if(props.task.isRemovable){
          disabled = false
        }
      }
    }
    return disabled;
  }

  return (
    <Menu
      className="ml-drop-menu"
      items={[
        {
          key: '1',
          label: <Text className="ml-drop-menu__label">Ver Tarea</Text>,
          icon: <FolderOpen />,
          onClick: openTask,
        },
        {
          key: '2',
          label: <Text className="ml-drop-menu__label">Clonar</Text>,
          icon: <Copy />,
          onClick: cloneTaskAction,
          className: hideCloneDelete() ? 'hide-button' : ''
        },
        {
          key: '3',
          label: <Text className="ml-drop-menu__label">Exportar</Text>,
          icon: <Download />,
          onClick: exportTask,
          className: hideExport() ? 'hide-button' : ''
        },
        {
          type: hideCloneDelete() ? 'group' : 'divider'
        },
        {
          key: '4',
          label: disabledDelete() ? <Text className="ml-drop-menu__label-delete-disable">Eliminar</Text> : <Text className="ml-drop-menu__label-delete-enable">Eliminar</Text>,
          icon: disabledDelete() ? <DeleteDisable /> : <DeleteEnable/>,
          disabled: disabledDelete(),
          onClick: deleteTaskAction,
          title: disabledDelete() ? 'La tarea contiene datos que no permiten eliminarla.' : '',
          className: hideCloneDelete() ? 'hide-button' : ''
        }
      ]}
    />
  );
}
export default DropDownMenu;
